import { CourseCard } from '@/components/ui/custom/coursePath/card/coursePathCard/CoursePathCard';
import { DesktopIcon } from '@/components/icons';
import StudentDashboardStats from '@/models/StudentDashboard';
import { getBannerImg } from '@/utils/coursePath';
import { ROUTES } from '@/utils/routes';

type Props = {
  dashboardStats: StudentDashboardStats;
  onClick: (courseProgressId: number) => void;
};

export default function ExtraCourseCard(props: Props) {
  const { dashboardStats, onClick } = props;

  const { coursePath, progress, progresses } = dashboardStats;

  const courseName = coursePath?.course?.name || '';

  const courseBannerImg = getBannerImg(coursePath);

  const remainingLessons =
    progresses.lessons.total - progresses.lessons.completed;

  return (
    <CourseCard to={ROUTES.COURSES.INFO(coursePath.slug)}>
      <CourseCard.Header>
        <CourseCard.Image
          src={courseBannerImg}
          onClick={() => onClick(dashboardStats.id)}
        />
      </CourseCard.Header>
      <CourseCard.Body className={{ base: 'flex flex-row gap-2 w-full' }}>
        <span className="flex flex-row gap-2 w-full">
          <CourseCard.Title text={courseName} />
          <CourseCard.ProgressIcon
            progress={progress}
            icon={<DesktopIcon className="w-4 h-4 shrink-0 text-info" />}
          />
        </span>
        <CourseCard.Formats formats={coursePath?.course?.formats} />
      </CourseCard.Body>

      <CourseCard.Footer className={{ base: 'flex flex-col gap-2 w-full' }}>
        <CourseCard.Progress value={progress} color="info" />
        <CourseCard.ProgressStats
          totalLessons={progresses.lessons.total}
          remainingLessons={remainingLessons}
          courseProgress={dashboardStats}
          className={{ section: 'text-info' }}
        />
      </CourseCard.Footer>
    </CourseCard>
  );
}
